import { css } from '@emotion/react'
import { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { withRouterProps } from '../../../utils'
import GoalList from './GoalList'
import { Page } from '../elements'
import { LabeledDivider, AddButton, TooltipText, HelpIcon } from '../../../components'

class GoalsDashboard extends Component {
  addAccount = () => {
    const { navigate } = this.props
    navigate('/goals/add')
  }

  render() {
    const {
      currentGoals,
      pastGoals,
      person: { displayName },
    } = this.props.store

    return (
      <Page>
        <Page.MainTitle>
          {displayName}'s
          <br />
          Goals
        </Page.MainTitle>
        <Page.Label>
          <strong>Planning to buy a “big ticket” item with retirement savings?</strong> Enter goals
          such as a down payment, new car, college tuition, etc. you’re planning to pay for with
          retirement savings. <HelpIcon tooltip={TooltipText.whatIsAGoal()} />
        </Page.Label>

        <GoalList goals={currentGoals} includeFill />
        {pastGoals.length > 0 && <LabeledDivider label='Past' />}
        <GoalList goals={pastGoals} />
        <AddButton
          label='Add new goal'
          link
          underline
          onClick={this.addAccount}
          width='100%'
          css={css`
            @media (max-width: 800px) {
              margin: auto;
            }
          `}
        />
      </Page>
    )
  }
}

export default withRouterProps(inject('store')(observer(GoalsDashboard)))
